import {
  columnDetails as pharmacyColumnDetails,
  computedColumns as pharmacyComputedColumns,
  tableHeaders as pharmacyTableHeaders,
  required as pharmacyRequired,
} from "../Processors/Schemas/PharmacyClaim";
import {
  columnDetails as medicalColumnDetails,
  computedColumns as medicalComputedColumns,
  tableHeaders as medicalTableHeaders,
  required as medicalRequired,
} from "../Processors/Schemas/MedicalClaim";
import {
  columnDetails as pharmacyEncounterColumnDetails,
  computedColumns as pharmacyEncounterComputedColumns,
  tableHeaders as pharmacyEncounterTableHeaders,
  required as pharmacyEncounterRequired,
} from "../Processors/Schemas/PharmacyEncounterClaim";
import {
  columnDetails as medicalEncounterColumnDetails,
  computedColumns as medicalEncounterComputedColumns,
  tableHeaders as medicalEncounterTableHeaders,
  required as medicalEncounterRequired,
} from "../Processors/Schemas/MedicalEncounterClaim";
const buildFields = (columnDetails) => {
  const fields = {};
  for (const col of columnDetails) {
    fields[col.name] = {
      label: col.label,
      title: col.title,
      description: col.description,
    };
  }
  return fields;
};

export const Fields = {
  medical: buildFields(medicalColumnDetails),
  pharmacy: buildFields(pharmacyColumnDetails),
  pharmacy_encounter: buildFields(pharmacyEncounterColumnDetails),
  medical_encounter: buildFields(medicalEncounterColumnDetails),
};

export const ComputedFields = {
  medical: medicalComputedColumns,
  pharmacy: pharmacyComputedColumns,
  pharmacy_encounter: pharmacyEncounterComputedColumns,
  medical_encounter: medicalEncounterComputedColumns,
};

const buildSchema = (tableHeaders, computedColumns) => {
  const schema = {};
  for (const field of [...tableHeaders, ...computedColumns]) {
    schema[field] = null;
  }
  return schema;
};

export const Schema = {
  medical: buildSchema(medicalTableHeaders, medicalComputedColumns),
  pharmacy: buildSchema(pharmacyTableHeaders, pharmacyComputedColumns),
  pharmacy_encounter: buildSchema(pharmacyEncounterTableHeaders, pharmacyEncounterComputedColumns),
  medical_encounter: buildSchema(medicalEncounterTableHeaders, medicalEncounterComputedColumns),
};

export const RequiredFields = {
  medical: medicalRequired,
  pharmacy: pharmacyRequired,
  pharmacy_encounter: pharmacyEncounterRequired,
  medical_encounter: medicalEncounterRequired,
};
